<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Zamówienia</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <router-link to="/order/list">Zamówienia</router-link>
        </li>
        <li class="active">
          <strong>Nowe</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isMainOpen = !isMainOpen">
            <h5>Dane zamówienia</h5>
            <span class="ibox-toggle">
              <i :class="chevronMainClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isMainOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Klient</label>
                <div v-if="clientsOptions" class="col-sm-10">
                  <Multiselect
                    v-model="orderObj.client"
                    mode="single"
                    placeholder="Klient"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="clientsOptions"
                  >
                  </Multiselect>
                  <div v-if="errorsAdminData?.data?.client" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.client[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Lokalizacja sklepu</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="orderObj.company_localization"
                    mode="single"
                    placeholder="Kraj"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="countryList"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.company_localization"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.company_localization[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Waluta</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="orderObj.currency"
                    mode="single"
                    placeholder="Waluta"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="currencyList"
                  >
                  </Multiselect>
                  <div v-if="errorsAdminData?.data?.currency" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.currency[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Język zamówienia</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="orderObj.lang"
                    mode="single"
                    placeholder="Język zamówienia"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="langList"
                  >
                  </Multiselect>
                  <div v-if="errorsAdminData?.data?.lang" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.lang[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Termin realizacji</label>
                <div class="col-sm-10">
                  <div class="form-group">
                    <VueDatePicker
                      :format="format"
                      v-model="realizationDate"
                      day-picker
                    />
                  </div>

                  <div
                    v-if="errorsAdminData?.data?.realization_date"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.realization_date[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Metoda płatności</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="orderObj.payment_method"
                    mode="single"
                    placeholder="Metoda płatności"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="apmOptions"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.payment_method"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.payment_method[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Wymuś status</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="orderObj.status"
                    mode="single"
                    placeholder="Wymuś status"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="statussesList"
                  >
                  </Multiselect>
                  <div v-if="errorsAdminData?.data?.status" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.status[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Koszt przesyłki</label>
                <div class="col-sm-10">
                  <input
                    v-model="orderObj.external_delivery_price"
                    type="number"
                    class="form-control inputClass"
                    placeholder="Koszt przesyłki"
                  />
                  <div
                    v-if="errorsAdminData?.data?.external_delivery_price"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.external_delivery_price[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="orderObj.my_address_as_sender"
                        type="checkbox"
                      />
                      <span>Wysyłka z adresem nadawcy</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="orderObj.is_invoice_paper"
                        type="checkbox"
                      />
                      <span>Faktura papierowa</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Produkty</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-horizontal">
                <div class="form-group">
                  <label class="control-label col-sm-2">Produkt</label>
                  <div class="col-sm-10">
                    <Multiselect
                      ref="prodSelect"
                      @change="selectProduct"
                      @open="onDropdownOpen"
                      @search-change="onSearchChange"
                      mode="single"
                      placeholder="Produkt"
                      track-by="name"
                      label="name"
                      :close-on-select="true"
                      :searchable="true"
                      :options="pOptions"
                    >
                    </Multiselect>
                    <div v-if="errorsAdminData?.data?.status" class="has-error">
                      <span class="help-block">
                        {{ errorsAdminData.data.status[0] }}
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  v-for="(item, index) in orderObj.order_products"
                  :key="index"
                  class="row"
                >
                  <hr />
                  <div class="col-sm-2">
                    <span>{{ index + 1 }}.</span>
                    <span class="label label-default">{{ item.pk }}</span>
                    <span>{{ item.name }}</span>
                    <br /><br />
                    <span>
                      (
                      <span>Grupa określająca liczbę stron:</span>
                      <span class="label label-default">
                        {{ item.option_group_for_page_count_pk }}
                      </span>
                      <span>{{ item.option_group_for_page_count_name }}</span>
                      )
                    </span>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label
                        for="external_quantity"
                        class="control-label col-sm-3"
                      >
                        Nakład
                      </label>
                      <div class="col-sm-9">
                        <input
                          v-model="item.external_quantity"
                          id="external_quantity"
                          type="number"
                          class="form-control"
                          placeholder="Nakład"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="net_price" class="control-label col-sm-3">
                        Cena netto
                      </label>
                      <div class="col-sm-9">
                        <input
                          v-model="item.net_price"
                          id="net_price"
                          type="number"
                          class="form-control"
                          placeholder="Cena netto"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-3">Format</label>
                      <div class="col-sm-9">
                        <Multiselect
                          v-model="item.external_format"
                          mode="single"
                          placeholder="Format"
                          track-by="name"
                          label="name"
                          :close-on-select="true"
                          :searchable="true"
                          :options="formats"
                        >
                        </Multiselect>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label col-sm-3">Plik</label>
                      <div class="col-sm-9">
                        <input
                          type="file"
                          class="form-control"
                          placeholder="Plik"
                          @change="changeFile($event, index)"
                        />
                        <div
                          v-if="
                            errorsAdminData?.data?.order_products[index]
                              .product_file
                          "
                          class="has-error"
                        >
                          <span
                            v-if="
                              errorsAdminData?.data?.order_products[index]
                                .product_file?.client_file
                            "
                            class="help-block"
                          >
                            {{
                              errorsAdminData?.data?.order_products[index]
                                .product_file?.client_file[0]
                            }}
                          </span>
                          <span
                            v-if="
                              errorsAdminData?.data?.order_products[index]
                                .product_file
                            "
                            class="help-block"
                          >
                            {{
                              errorsAdminData?.data?.order_products[index]
                                .product_file[0]
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="form-group">
                      <label class="control-label col-sm-3">Opcje</label>
                      <div class="col-sm-9">
                        <Multiselect
                          ref="optSelect"
                          v-model="item.chosen_options"
                          @open="onDropdownOpenOpt"
                          @search-change="onSearchChangeOpt"
                          mode="tags"
                          placeholder="Opcje"
                          track-by="name"
                          label="name"
                          :close-on-select="false"
                          :searchable="true"
                          :options="options"
                        >
                        </Multiselect>
                        <div
                          v-if="
                            errorsAdminData?.data?.order_products[index]
                              .chosen_options
                          "
                          class="has-error"
                        >
                          <span class="help-block">
                            {{
                              errorsAdminData?.data?.order_products[index]
                                .chosen_options[0]
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <button
                      @click="removeProduct(index)"
                      class="btn btn-danger"
                    >
                      <span class="fa fa-times"></span>
                      <span> Usuń</span>
                    </button>
                    <br />
                    <button @click="cloneProduct(item)" class="btn btn-primary">
                      <span class="fa fa-copy"></span>
                      <span> Powiel</span>
                    </button>
                  </div>
                </div>

                <div class="form-group">
                  <div class="col-sm-4 col-sm-offset-2">
                    <router-link class="btn btn-white" to="/order/list">
                      Anuluj
                    </router-link>
                    <button
                      v-if="canAddOrder"
                      @click="create"
                      class="btn btn-primary"
                    >
                      Dodaj
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import router from "../../router/router";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import { hasPermission } from "../../permissions";
import { orderPermissionsConst } from "../../constants/orderConstants";

export default {
  name: "OrderCreate",
  mixins: [],
  components: {
    Multiselect,
  },
  props: {},

  setup() {
    const countryList = ref([
      { name: "Polska", value: "PL" },
      { name: "Niemcy", value: "DE" },
    ]);
    const currencyList = ref([
      { name: "PLN", value: "PLN" },
      { name: "EUR", value: "EUR" },
    ]);
    const langList = ref([
      { name: "PL", value: "pl" },
      { name: "DE", value: "de" },
      { name: "EN", value: "en" },
      { name: "DE [DE]", value: "cpde" },
      { name: "EN [DE]", value: "cpen" },
    ]);
    const statussesList = ref([
      { name: "W produkcji", value: "in_production" },
    ]);

    const errorsAdminData = ref();
    const showErrors = ref(false);
    const isMainOpen = ref(true);
    const store = useStore();
    const clientsContactData = computed(
      () => store.getters.getClientsContactData
    );
    const adminProductsOptionsData = computed(
      () => store.getters.getAdminProductsOptionsData
    );
    const apmData = computed(() => store.getters.getApmData);
    const createOrderData = computed(() => store.getters.getCreateOrderData);
    const productFormatsData = computed(
      () => store.getters.getProductFormatsData
    );
    const productSearchData = computed(
      () => store.getters.getAdminProductSearchData
    );
    const countriesData = computed(() => store.getters.getCountriesData);
    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const clientsOptions = ref([]);
    const apmOptions = ref([]);
    const adminsComplaint = ref([]);
    const countriesOptions = ref([]);
    const pOptions = ref([]);
    const formats = ref([]);
    const options = ref([]);
    const realizationDate = ref();
    const poPage = ref(1);
    const psPage = ref(1);
    const prodSelect = ref(null);
    const optSelect = ref(null);
    const orderObj = ref({
      client: [],
      order_products: [],
    });
    const canAddOrder = computed(() =>
      hasPermission(orderPermissionsConst.add)
    );

    const create = () => {
      if (!canAddOrder.value) {
        return;
      }

      showErrors.value = true;
      if (orderObj.value) {
        store.dispatch("createOrder", orderObj.value);
      }
    };

    const format = (date) => {
      let day, month, year;
      day = date.getDate();
      month = ("0" + (date.getMonth() + 1)).slice(-2);
      year = date.getFullYear();

      return `${day}.${month}.${year}`;
    };

    const selectProduct = (product) => {
      product.chosen_options = [];
      product.product = product.pk;
      orderObj.value.order_products.push(product);
    };

    const removeProduct = (index) => {
      orderObj.value.order_products.splice(index, 1);
    };

    const cloneProduct = (item) => {
      orderObj.value.order_products.push({
        name: item.name,
        option_group_for_page_count_name: item.option_group_for_page_count_name,
        option_group_for_page_count_pk: item.option_group_for_page_count_pk,
        chosen_options: item.chosen_options,
        external_format: item.external_format,
        pk: item.pk,
      });
    };

    const changeFile = (file, index) => {
      if (file.srcElement?.files[0]) {
        orderObj.value.order_products[index].product_file =
          file.srcElement?.files[0];
      }
    };

    const onDropdownOpen = () => {
      setTimeout(() => {
        const optionsList = prodSelect.value?.$el?.querySelector(
          ".multiselect-options"
        );
        const scrollContainer = optionsList?.parentElement;
        if (scrollContainer) {
          scrollContainer.removeEventListener("scroll", onScroll);
          scrollContainer.addEventListener("scroll", onScroll);
        }
      }, 100);
    };

    const onDropdownOpenOpt = () => {
      setTimeout(() => {
        const optionsList = optSelect.value[0]?.$el?.querySelector(
          ".multiselect-options"
        );
        // optionsList
        const scrollContainer = optionsList?.parentElement;
        if (scrollContainer) {
          scrollContainer.removeEventListener("scroll", onScrollOpt);
          scrollContainer.addEventListener("scroll", onScrollOpt);
        }
      }, 500);
    };

    const onScroll = (e) => {
      const el = e.target;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
        poPage.value++;
        store.dispatch("getAdminProductsOptions", { page: poPage.value });
      }
    };

    const onScrollOpt = (e) => {
      const el = e.target;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
        psPage.value++;
        store.dispatch("getAdminProductSearchOptions", { page: psPage.value });
      }
    };

    const onSearchChange = (query) => {
      store.dispatch("getAdminProductsOptions", {
        page: poPage.value,
        name: query,
      });
    };

    const onSearchChangeOpt = (query) => {
      store.dispatch("getAdminProductSearchOptions", {
        page: psPage.value,
        name: query,
      });
    };

    store.dispatch("getClientsContact");
    store.dispatch("getCountriesList");
    store.dispatch("getApm");
    store.dispatch("getAdminProductsOptions", { page: poPage.value });
    store.dispatch("getProductFormats");
    store.dispatch("getAdminProductSearchOptions", { page: psPage.value });

    watch(
      () => realizationDate.value,
      function (newValue) {
        orderObj.value.realization_date = format(newValue);
      }
    );

    watch(
      () => productSearchData.value,
      function (newValue) {
        if (newValue.status === 200) {
          newValue.data?.results.forEach((element) => {
            options.value.push({
              name:
                "[" +
                element.options_group +
                "] " +
                element.options_group_name +
                " [" +
                element.pk +
                "] " +
                element.label,
              value: { chosen_option: element.pk },
            });
          });
        }
      }
    );

    watch(
      () => productFormatsData.value,
      function (newValue) {
        if (newValue.status === 200) {
          newValue.data?.forEach((element) => {
            formats.value.push({
              name:
                "[" +
                element.pk +
                "] " +
                element.size_x +
                " x " +
                element.size_y,
              value: element.pk,
            });
          });
        }
      }
    );

    watch(
      () => createOrderData.value,
      async function (newValue) {
        if (newValue.status === 200) {
          router.push({ name: "OrderList", path: "/order/list" }).then(() => {
            store.dispatch("showToaster", {
              type: "success",
              content: "Nowe zamówienie zostało dodane!",
            });
          });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );
    watch(
      () => clientsContactData.value,
      function (newValue) {
        newValue.data.results?.forEach((element) => {
          clientsOptions.value.push({
            name: "[" + element.pk + "] " + element.full_name,
            value: element.pk,
          });
        });
      }
    );

    watch(
      () => apmData.value,
      function (newValue) {
        newValue.data?.data?.forEach((element) => {
          apmOptions.value.push({
            name: element[1],
            value: element[0],
          });
        });
      }
    );

    watch(
      () => countriesData.value,
      function (newValue) {
        newValue.data.data?.forEach((element) => {
          countriesOptions.value.push({
            name: element.name_pl,
            value: element.code,
          });
        });
      }
    );

    watch(
      () => adminProductsOptionsData.value,
      function (newValue) {
        if (newValue.status === 200) {
          newValue.data?.results.forEach((element) => {
            pOptions.value.push({
              name: "[" + element.pk + "] " + element.name,
              value: element,
            });
          });
        }
      }
    );

    return {
      countryList,
      currencyList,
      langList,
      errorsAdminData,
      showErrors,
      create,
      canAddOrder,
      clientsOptions,
      adminsComplaint,
      countriesOptions,
      orderObj,
      format,
      apmOptions,
      statussesList,
      pOptions,
      formats,
      options,
      selectProduct,
      changeFile,
      removeProduct,
      cloneProduct,
      realizationDate,
      onDropdownOpen,
      onDropdownOpenOpt,
      prodSelect,
      optSelect,
      onSearchChange,
      onSearchChangeOpt,
      isMainOpen,
      chevronMainClass,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}

.ibox-toggle:hover {
  color: #333;
}
</style>
